"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAccountInfo = exports.fetchNFTDetail = exports.getMetaDataJSON = void 0;
var metaplex_js_1 = require("@renec-foundation/metaplex-js");
var web3_js_1 = require("@solana/web3.js");
var spl_token_1 = require("spl-token");
var IMAGE_MIME_TYPE_REGEX = /data:image\/(svg\+xml|png|jpeg|gif)/g;
var Metadata = metaplex_js_1.programs.metadata.Metadata;
var getMetaDataJSON = function (id, metadata) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, new Promise(function (resolve) {
                var uri = metadata.data.uri;
                if (!uri)
                    return resolve(undefined);
                var processJson = function (extended) {
                    var _a, _b;
                    if (!extended || (!extended.image && ((_b = (_a = extended === null || extended === void 0 ? void 0 : extended.properties) === null || _a === void 0 ? void 0 : _a.files) === null || _b === void 0 ? void 0 : _b.length) === 0)) {
                        return;
                    }
                    if (extended === null || extended === void 0 ? void 0 : extended.image) {
                        extended.image =
                            extended.image.startsWith('http') || IMAGE_MIME_TYPE_REGEX.test(extended.image)
                                ? extended.image
                                : "".concat(metadata.data.uri, "/").concat(extended.image);
                    }
                    return extended;
                };
                try {
                    fetch(uri)
                        .then(function (_) { return __awaiter(void 0, void 0, void 0, function () {
                        var data, _a;
                        return __generator(this, function (_b) {
                            switch (_b.label) {
                                case 0:
                                    _b.trys.push([0, 2, , 3]);
                                    return [4 /*yield*/, _.json()];
                                case 1:
                                    data = _b.sent();
                                    resolve(processJson(data));
                                    return [3 /*break*/, 3];
                                case 2:
                                    _a = _b.sent();
                                    resolve(undefined);
                                    return [3 /*break*/, 3];
                                case 3: return [2 /*return*/];
                            }
                        });
                    }); })
                        .catch(function () {
                        resolve(undefined);
                    });
                }
                catch (ex) {
                    console.error(ex);
                    resolve(undefined);
                }
            })];
    });
}); };
exports.getMetaDataJSON = getMetaDataJSON;
var fetchNFTDetail = function (nftAddress, connection) { return __awaiter(void 0, void 0, void 0, function () {
    var nftData, pda, metadata, metadataJSON, error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 5, , 6]);
                nftData = null;
                return [4 /*yield*/, Metadata.getPDA(new web3_js_1.PublicKey(nftAddress))];
            case 1:
                pda = _a.sent();
                return [4 /*yield*/, Metadata.load(connection, pda)];
            case 2:
                metadata = _a.sent();
                if (!metadata) return [3 /*break*/, 4];
                return [4 /*yield*/, (0, exports.getMetaDataJSON)(nftAddress, metadata.data)];
            case 3:
                metadataJSON = _a.sent();
                nftData = {
                    json: metadataJSON,
                    metadata: metadata.data,
                };
                _a.label = 4;
            case 4: return [2 /*return*/, nftData];
            case 5:
                error_1 = _a.sent();
                return [2 /*return*/, null];
            case 6: return [2 /*return*/];
        }
    });
}); };
exports.fetchNFTDetail = fetchNFTDetail;
var getAccountInfo = function (address, connection) { return __awaiter(void 0, void 0, void 0, function () {
    var err_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, (0, spl_token_1.getAccount)(connection, address)];
            case 1: return [2 /*return*/, _a.sent()];
            case 2:
                err_1 = _a.sent();
                return [2 /*return*/, null];
            case 3: return [2 /*return*/];
        }
    });
}); };
exports.getAccountInfo = getAccountInfo;
